import React, { useEffect, useState } from 'react'
import {
   Card,
   CardHeader,
   Checkbox,
   Divider,
   FormControlLabel,
   makeStyles,
   CardContent,
   FormControl,
   FormGroup,
   RadioGroup,
   Radio,
   IconButton
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import PropTypes from 'prop-types'
import '../styles/scrollBlueSections.css'

const useStyles = makeStyles(theme => ({
   root: {
      height: '250px',
      overflow: 'auto'
   },
   Card: {
      borderTop: '4px solid #1665D8',
      margin: 2
   },
   CardHeader: {
      minHeight: 48,
      padding: 10,
      '& .MuiTypography-subtitle1': {
         fontSize: '14px',
         fontWeight: 700
      }
   },
   formControl: {
      margin: theme.spacing(0)
   },
   itemSelected: {
      background: '#F5F7FD',
      borderRadius: '4px',
      marginRight: -10
   },
   itemText: {
      fontSize: 12
   },
   iconSuccess: {
      color: '#37C846'
   }
}))

const ListSelector = ({
   title = '',
   subheader = '',
   listItem,
   onlySelection = false,
   listSelectionCallback
}) => {
   const classes = useStyles()
   const [itemsSelected, setItemsSelected] = useState(onlySelection ? 0 : [])

   useEffect(() => {
      sendCallBack()
   }, [itemsSelected])

   const handleCheck = e => {
      const { checked, value } = e.target
      const idItem = value
      if (onlySelection) {
         setItemsSelected(idItem)
      } else {
         setItemsSelected(rest => ({
            ...rest,
            [idItem]: checked
         }))
      }
   }

   const selectedItems = () => {
      const selection = []
      for (const [key, value] of Object.entries(itemsSelected)) {
         if (value) {
            selection.push(key)
         }
      }
      return selection
   }

   const sendCallBack = () => {
      let rolesList
      if (typeof itemsSelected === 'object') {
         rolesList = selectedItems()
      } else {
         rolesList = [itemsSelected.toString()]
      }
      listSelectionCallback(rolesList)
   }

   const currentItemSelected = idItem => {
      if (typeof idItem === 'string' || typeof idItem === 'number') {
         return itemsSelected === idItem
      }
      return itemsSelected.includes(idItem)
   }

   return (
      <Card className={classes.Card}>
         <CardHeader
            className={classes.CardHeader}
            classes={{
               title: {
                  fontWeight: 700,
                  fontSize: 14
               }
            }}
            title={
               title.replace('%n%', selectedItems().length) ??
               `${selectedItems().length} seleccionados`
            }
            subheader={subheader}
            titleTypographyProps={{
               variant: 'subtitle1'
            }}
            subheaderTypographyProps={{
               variant: 'body2'
            }}
            action={
               <IconButton style={{ marginBottom: -8 }} disabled>
                  {listItem.length ? (
                     <CheckCircleIcon
                        fontSize="small"
                        className={classes.iconSuccess}
                     />
                  ) : null}
               </IconButton>
            }
         ></CardHeader>
         <Divider />
         <CardContent className={`${classes.root} blue-scroll-section`}>
            {listItem.map((val, idx) => (
               <FormControl
                  fullWidth={true}
                  component="fieldset"
                  className={classes.formControl}
               >
                  {onlySelection ? (
                     <RadioGroup value={itemsSelected}>
                        <FormControlLabel
                           onChange={handleCheck}
                           control={<Radio color="primary" />}
                           className={`${
                              currentItemSelected(val.id)
                                 ? classes.itemSelected
                                 : ''
                           }`}
                           label={
                              <span style={{ fontSize: '0.8rem' }}>
                                 {val.name}
                              </span>
                           }
                           value={val.id}
                        />
                     </RadioGroup>
                  ) : (
                     <FormGroup>
                        <FormControlLabel
                           className={`${
                              currentItemSelected(val.id)
                                 ? classes.itemSelected
                                 : ''
                           }`}
                           control={
                              <Checkbox
                                 onChange={handleCheck}
                                 name={val.name}
                                 inputProps={{ 'aria-label': val?.name }}
                                 id={val.id}
                                 value={val.id}
                                 color="primary"
                              />
                           }
                           label={
                              <span style={{ fontSize: '0.8rem' }}>
                                 {val.name}
                              </span>
                           }
                        />
                     </FormGroup>
                  )}
               </FormControl>
            ))}
         </CardContent>
      </Card>
   )
}

ListSelector.propTypes = {
   listSelectionCallback: PropTypes.node.isRequired,
   listItem: PropTypes.array.isRequired
}

export default ListSelector
